import "./SampleArtwork.css";
import { isStarterPhoto, STARTER_PHOTOS, starterPhotoUrl } from "../../../lib/starterPhotos";

/** Built-in art: a starter photograph, or one of the two illustrations. */
export function SampleArtwork({ kind }: { kind: string }) {
  if (isStarterPhoto(kind))
    return (
      <img
        src={starterPhotoUrl(kind)}
        alt={STARTER_PHOTOS[kind].alt}
        draggable={false}
        loading="lazy"
        // Portrait beside words in a column, so it holds its own there.
        className="sample-artwork block aspect-[1.5] max-h-[32rem] w-full rounded-site bg-hazumu-border object-cover [.site-column_&]:aspect-[4/5]"
      />
    );
  return (
    <div
      className={`sample-artwork relative isolate grid aspect-[1.5] w-full place-items-center overflow-hidden rounded-site ${kind === "kindred" ? "sample-artwork-clay bg-hazumu-clay" : "bg-hazumu-sage-pale"}`}
      role="img"
      aria-label="Illustrative sample artwork"
    >
      <span className={`font-[Georgia,serif] text-[clamp(24px,6vw,72px)] ${kind === "kindred" ? "text-hazumu-ink" : "text-hazumu-warm-white"}`}>{kind === "kindred" ? "kindred" : "flora"}</span>
    </div>
  );
}
